import { IonIcon } from "@ionic/react";
import { save } from "ionicons/icons";
import {
  FloatingButton,
  FloatingButtonProps,
} from "../FloatingButton/FloatingButton";

export function FloatingSaveButton(props: FloatingButtonProps) {
  return (
    <FloatingButton {...props}>
      <IonIcon icon={save} />
      Gem
    </FloatingButton>
  );
}
